<template>
  <div>
    <form action="catalogsearch/result/" method="get">
      <label for="procura">
        <input 
          id="procura"
          type="text"
          placeholder="Procurar..."
          onfocus="this.placeholder=''"
          onblur="this.placeholder='Procurar...'"
        >
      </label>
      <select name="cat" id="" >
        <option value="item.id" v-for="(item,index) in categorias" v-bind:key="index">{{item.name}}</option>
      </select>
      <button type="submit" title="Procurar">       
        <icon-base icon-name="search"><icon-search /></icon-base>
      </button>
    </form>
  </div>
</template>

<script>
  import IconBase from './IconBase';
  import IconSearch from './icons/IconSearch'

  const components = {
    IconBase,
    IconSearch
  }

  const computed = {
    categorias() {
      let list = []
      list.push({id:"", name: 'Toda a Loja'})
      for (let item of this.$store.state.categories.list) {
        let name = (item.own ? "- " : "") + item.name;
        list.push({
          id: item.id,
          name,
        })
      }
      return list;
    }
  }

  export default {
    name: 'SearchArea',
    computed,
    components
  }
</script>

<style scoped>
  *, ::placeholder {
    background-color: transparent;
    color: #ddd;
  }
  form {
    background-color: #006393;
    border-radius: 1rem;
  }
  label {
    display: inline-block;
    padding: 1rem;
  }
  input {
    border: 0;
    outline: none;
  }
  select {
    border: 0;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    height: 3rem;
    outline: none;
  }
  button {
    border: 0;
    outline: none;
    height: 3rem;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
  button:hover {
    background: rgb(27,81,117);
  }
  option {
    color: #000;
  }
</style>